import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  count = 0;
  constructor(private spinner: NgxSpinnerService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!new RegExp(['auth'].join("|")).test(req.url)) {
      this.spinner.show();
      this.count++;
    }
    return next.handle(req)
      .pipe(tap(
        event => { }, error => { }
      ), finalize(() => {
        if (this.count > 0) this.count--;
        if (this.count == 0) this.spinner.hide();
      })
      );
  }
}